import _ from 'lodash';
import * as moment from 'moment';
import { RRule } from 'rrule';
import React from 'react';
import * as TaskUtilities from '../../../../../HelperMethods/TaskUtilities';
import { EVENT_SOURCE, STATUS_LIST } from '../../../../../HelperMethods/enums';
import * as DateUtils from '../../../../../HelperMethods/DateUtils';
import * as RRuleFunctions from '../../../../../HelperMethods/RRuleFunctions';
// eslint-disable-next-line import/no-cycle
// import rootReducer from '../../../../../reducers'
import {
  PICKLIST_OPTIONS,
  RRULE_FREQUENCY_MAP,
  INPUT_TYPE_FORMAT,
  RecurringFormFields,
  RESOLVED_VIA,
} from './constants';
import { determineIfUserHasFieldsDisabled } from '../../../../../HelperMethods/UserUtilities';
import { ACCESS_OPTIONS, ENTITY_ACCESS_TYPE, RESOURCES } from '../../../../../HelperMethods/role-resource-constants';
import PartsComponent from '../PartsComponent';
// eslint-disable-next-line import/no-cycle
import AssigneeComponentBulkEdit from '../AssigneeComponentBulkEdit';
import { mapErrorToField } from './Mapper';
import { ATTRIBUTE_TYPE } from '../../../../../HelperMethods/FormUtils';
import ApprovalRequirementComponent from '../ApprovalMatrixInfo/ApprovalRequirementComponent';
// eslint-disable-next-line import/no-cycle
import AssigneeComponent from '../AssigneeComponent';
import AssetCriteriaComponent from '../AssetCriteriaComponent';
import TaskIndicatorComponent from '../TaskIndicatorComponent';
// eslint-disable-next-line import/no-cycle
import TaskAdhocAttachment from '../TaskAdhocAttachment';
import LocationTaskFieldComponent from '../LocationTaskFieldComponent';
import PriorityForTask from '../PriorityForTask';
import TimeToNextPriority from '../TimeToNextPriority';
import PriorityForTaskBulkEdit from '../PriorityForTaskBulkEdit';
import TaskNumberComponent from '../TaskNumberComponent';
import AssetLevelInfoComponent from '../AssetLevelInfo';

// eslint-disable-next-line no-unused-vars
function prioirtyShouldBevisible(selectedTasks) {
  // check for priorityTemplate, if single templete then show or not show
  const priorityTemplateStack = [];
  selectedTasks.forEach((e) => {
    if (!priorityTemplateStack.includes(e.priorityTemplate)) {
      priorityTemplateStack.push(e.priorityTemplate);
    }
  });
}

export const ATTACHMENT_SCHEMA = 'attachment';

const initVal = {
  allowPileups: true,
  overwriteEditedOccurrences: true,
};

export const BULK_EDIT_SCHEMA = {
  s_priority: {
    name: 'priority',
    displayName: 'Priority',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(PriorityForTaskBulkEdit, { ...props }),
    disabled: ({ loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.PRIORITY,
        user: loggedInUser,
      }),
    sequence: 6,
    path: 'priority',
  },

  s_workordernumber: {
    name: 'workordernumber',
    displayName: 'Work Order Number',
    type: ATTRIBUTE_TYPE.STRING,
    sequence: 8,
    path: 'data.s_workordernumber',
  },
  s_status: {
    name: 'status',
    displayName: 'Status',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 10,
    optionsVariableName: PICKLIST_OPTIONS.STATUS,
    path: 'status',
    isMandatory: false,
    disabled: ({ loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STATUS,
        user: loggedInUser,
      }),
  },

  s_timespent: {
    display_format: 'hh:mm',
    name: 'Task Time',
    type: 'time',
    hide: true,
    setValue: () => {
      return null;
    },
  },
  s_name: {
    name: 'Task Name',
    type: 'string',
    hide: true,
    setValue: ({ formValues, taskTypeOptions }) => {
      const taskType = taskTypeOptions.items.find((tt) => tt.value === formValues.s_tasktype);
      if (taskType) {
        return {
          data: {
            s_name: taskType.originalobject.name,
          },
        };
      }
      return {};
    },
  },
  s_estimatedtime: {
    display_format: 'hh:mm',
    name: 'Estimated Time',
    type: 'time',
    hide: true,
  },
  s_workflowversion: {
    name: 'workflowVersion',
    type: 'string',
    hide: true,
    setValue: ({ formValues, taskTypeOptions }) => {
      const taskType = taskTypeOptions.items.find((tt) => formValues.s_tasktype === tt.value);
      if (taskType && taskType.originalobject.isParent) {
        return { workflowVersion: 'v1' };
      }
      return {};
    },
  },
  s_fieldId: {
    name: 'fieldId',
    type: 'string',
    hide: true,
    setValue: ({ fieldId }) => {
      return { fieldId };
    },
  },
  s_cost: {
    name: 'Costs',
    type: 'decimal',
    uom: 'USD',
    hide: true,
  },
  // s_cummulativehourrate: {
  //   name: 'cumulativeHourRate',
  //   displayName: 'Cumulative Hourly Rate($)',
  //   disabled: true,
  //   hide: true,
  //   type: ATTRIBUTE_TYPE.DECIMAL,
  //   value: ({ formValues, assigneeOptions }) => {
  //     const assigneeIds = _.get(formValues, 's_assigneeid', []);
  //     const assigneeOptionsKeyed = _.keyBy(assigneeOptions.items, 'key');
  //     const cumulativeHourRate = assigneeIds.reduce((totalRate, assigneeId) => {
  //       return totalRate + _.get(assigneeOptionsKeyed, `${assigneeId}.originalobject.contractHourlyRate`, 0);
  //     }, 0);
  //     return `${cumulativeHourRate}`;
  //   },
  // },
  // s_isrecurring: {
  //   name: 'isRecurring',
  //   hide: true,
  //   setValue: ({ task, formValues }) => {
  //     return {
  //       isRecurring: !!(!task.sourceRecurringTaskId && formValues.schedule_eventsource === EVENT_SOURCE.RECURRING),
  //     };
  //   },
  // },
  s_assigneeid: {
    name: 'assigneeid',
    displayName: 'Assignees',
    type: ATTRIBUTE_TYPE.CUSTOM,
    // eslint-disable-next-line react/jsx-filename-extension
    component: (props) => <AssigneeComponentBulkEdit {...props} />,
    sequence: 13,
    path: 'assigneeIds',

    optionsVariableName: PICKLIST_OPTIONS.ASSIGNEE,
    fullRow: true,
    componentWidth: 12,
  },
  s_isHardAssignee: {
    name: 'isHardAssignee',
    displayName: 'Strict Hard Assignment',
    type: ATTRIBUTE_TYPE.CHECKBOX,
    sequence: 14,
    path: 'isHardAssignee',
    disabled: ({ task, loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STRICT_HARD_ASSIGNMENT,
        user: loggedInUser,
      }),
    hide: ({ selectedTasks = [] }) => {
      return selectedTasks?.some((task) => TaskUtilities.isTaskParent(task));
    },
  },
  schedule_hardstarttime: {
    name: 'hardStartTime',
    displayName: 'Hard Start Time',
    type: ATTRIBUTE_TYPE.CHECKBOX,
    sequence: 7,
    path: 'isHardStartTime',
    disabled: ({ loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STRICT_HARD_START_TIME,
        user: loggedInUser,
      }),
  },
  schedule_duedate: {
    name: 'dueDate',
    displayName: 'Date',
    type: ATTRIBUTE_TYPE.DATE,
    sequence: 2,
    path: () => {
      return '';
    },
    hide: ({ selectedTasks = [] }) => {
      return selectedTasks.some((task) => task.eventSource === EVENT_SOURCE.RECURRING && !task.sourceRecurringTaskId);
    },
    isMandatory: false,
    fullRow: true,
    validations: [
      {
        validateFunc: ({ formValues, selectedTasks = [] }) => {
          const isdueDateFieldHidden = selectedTasks.some(
            (task) => task.eventSource === EVENT_SOURCE.RECURRING && !task.sourceRecurringTaskId
          );
          if (isdueDateFieldHidden) {
            return true;
          }
          const dueDate = _.get(formValues, 'schedule_duedate', '');
          const startTime = _.get(formValues, 'schedule_starttime', '');

          if (_.isEmpty(dueDate) && _.isEmpty(startTime)) return true;

          if (!_.isEmpty(dueDate) && !_.isEmpty(startTime)) return true;
          if (_.isEmpty(dueDate)) return false;

          return true;
        },
        message: 'Date cannot be Empty if Time is Filled',
      },
    ],
    disabled: ({ selectedTasks = [], loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return selectedTasks.some((task) => task.isTaskLocked);
    },
  },
  schedule_starttime: {
    name: 'startTime',
    displayName: 'Start Time',
    type: ATTRIBUTE_TYPE.TIME,
    sequence: 3,
    path: () => {
      return null;
    },
    isMandatory: false,
    setValue: ({ formValues }) => {
      if (formValues && formValues.schedule_starttime)
        return {
          startTime: DateUtils.convertToUTCDate(
            formValues?.schedule_duedate || moment().format(INPUT_TYPE_FORMAT.date),
            formValues.schedule_starttime
          ).toISOString(),
        };
      return null;
    },
    validations: [
      {
        validateFunc: ({ formValues }) => {
          const dueDate = _.get(formValues, 'schedule_duedate', '');
          const startTime = _.get(formValues, 'schedule_starttime', '');

          if (_.isEmpty(dueDate) && _.isEmpty(startTime)) return true;

          if (!_.isEmpty(dueDate) && !_.isEmpty(startTime)) return true;
          if (_.isEmpty(startTime)) return false;

          return true;
        },
        message: 'Start Time cannot be Empty if Date is Filled',
      },
    ],
    disabled: ({ selectedTasks = [], loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return selectedTasks.some((task) => task.isTaskLocked);
    },
    step: 1,
  },
  schedule_duration: {
    name: 'duration',
    displayName: 'Default Duration(Minutes)',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 4,
    path: 'duration',
    isMandatory: false,
    disabled: ({ selectedTasks = [], loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return selectedTasks.some((task) => task.isTaskLocked);
    },
  },
  schedule_endtime: {
    name: 'endTime',
    displayName: 'End Time',
    type: ATTRIBUTE_TYPE.TIME,
    sequence: 5,
    disabled: true,
    value: ({ formValues }) => {
      const startTime = formValues?.schedule_starttime;
      if (!startTime) {
        return '';
      }
      const dueDate = formValues?.schedule_duedate || moment().format(INPUT_TYPE_FORMAT.date);
      const duration = formValues?.schedule_duration || 0;
      return moment(`${dueDate}T${startTime}`).add(duration, 'minutes').format(INPUT_TYPE_FORMAT.time);
    },
    setValue: ({ formValues }) => {
      if (formValues && formValues.schedule_starttime)
        return {
          endTime: moment(
            DateUtils.convertToUTCDate(
              formValues?.schedule_duedate || moment().format(INPUT_TYPE_FORMAT.date),
              formValues.schedule_starttime
            )
          )
            .add(formValues.schedule_duration, 'minutes')
            .toISOString(),
        };
      return null;
    },
    step: 1,
  },
  schedule_delayminutes: {
    name: 'delayMinutes',
    displayName: 'Delayed By',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 6,
    path: 'delayMinutes',
    disabled: ({ loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      return disabled;
    },
  },
  notification_watchers: {
    name: 'watchers',
    displayName: 'Watchers',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 1,
    path: 'watcherIds',
    optionsVariableName: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS,
    multiple: true,
  },
  watcher_groups: {
    name: 'watcherGroups',
    displayName: 'Watcher Groups',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 1,
    path: 'watcherGroupIds',
    optionsVariableName: PICKLIST_OPTIONS.WATCHER_GROUPS,
    multiple: true,
  },
  [ATTACHMENT_SCHEMA]: {
    name: 'attachments',
    displayName: 'Attachment',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(TaskAdhocAttachment, { ...props }),
    path: 'attachments',
  },
  schedule_recurring: {
    name: 'recurring',
    displayName: 'Recurring Details',
    type: ATTRIBUTE_TYPE.CUSTOM,
    // eslint-disable-next-line react/jsx-filename-extension
    component: (props) => <RecurringFormFields {...props} />,
    sequence: 2,
    fullRow: true,
    disabled: ({ loggedInUser, selectedTasks = [] }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: ENTITY_ACCESS_TYPE.UPDATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return selectedTasks.some((task) => !!TaskUtilities.isTaskChild(task));
    },
    path: () => {
      return initVal;
    },
    setValue: () => {
      return { schedule: null };
    },
    hide: ({ selectedTasks = [] }) => {
      return selectedTasks.some((task) => task.eventSource !== EVENT_SOURCE.RECURRING || task.sourceRecurringTaskId);
    },
    validations: [
      {
        validateFunc: ({ formValues }) => {
          if (_.isEqual(initVal, formValues.schedule_recurring)) {
            return true;
          }
          const startDate = _.get(formValues, 'schedule_recurring.startdate');
          const endDate = _.get(formValues, 'schedule_recurring.enddate');
          if (startDate && endDate) {
            return endDate > startDate;
          }
          return true;
        },
        message: 'End Date should be greater than Start Date',
      },
      {
        validateFunc: ({ formValues }) => {
          if (_.isEqual(initVal, formValues.schedule_recurring)) {
            return true;
          }
          const frequencyType = _.get(formValues, 'schedule_recurring.frequencytype');
          const byWeekday = _.get(formValues, 'schedule_recurring.byweekday');
          if (frequencyType && frequencyType === RRULE_FREQUENCY_MAP[RRule.WEEKLY]) {
            return !!(byWeekday && byWeekday.length > 0);
          }
          return true;
        },
        message: 'Please select at least one week day',
      },
      {
        validateFunc: ({ formValues }) => {
          if (_.isEqual(initVal, formValues.schedule_recurring)) {
            return true;
          }
          const displayUptoDays = _.get(formValues, 'schedule_recurring.displayUptoDays');
          if (displayUptoDays > 60 || displayUptoDays < 0) {
            return false;
          }
          return true;
        },
        message: 'The value should be between 0 and 60 (including)',
      },
    ],
  },
};

export const DEFAULT_TASK_SCHEMA = {
  s_tasknumber: {
    name: 'tasknumber',
    displayName: 'Task Number',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(TaskNumberComponent, { ...props }),
    sequence: 1,
    path: 'taskNumber',
    hide: ({ task }) => !task.id,
    disabled: true,
  },
  s_taskIndicator: {
    displayName: 'Task Indicator',
    attributeName: 'taskIndicator',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(TaskIndicatorComponent, { ...props }),
    sequence: 2,
    hide: ({ task }) => !task.id,
  },
  s_tasktype: {
    name: 'tasktype',
    displayName: 'Task Type',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 3,
    path: 'taskTypeId',
    optionsVariableName: PICKLIST_OPTIONS.TASK_TYPE,
    onChange: 'onTaskTypeChange',
    // task should be disabled while editing only if
    // its a child,parent,occurence rrecurring,series recurring
    disabled: ({ task }) => {
      if (!task?.id) {
        return false;
      }
      if (
        task?.id &&
        !TaskUtilities.isTaskChild(task) &&
        !TaskUtilities.isTaskOccurrenceOfRecurring(task) &&
        TaskUtilities.isTaskRegular(task) &&
        !task?.taskType?.defaultLocationTask
      ) {
        return false;
      }
      return true;
    },
    isMandatory: true,
  },
  s_workordernumber: {
    name: 'workordernumber',
    displayName: 'Work Order Number',
    type: ATTRIBUTE_TYPE.STRING,
    sequence: 4,
    path: 'data.s_workordernumber',
  },
  s_stop: {
    name: 'stop',
    displayName: 'Stop',
    type: ATTRIBUTE_TYPE.CUSTOM,
    sequence: 5,
    isMandatory: true,
    path: (task) => {
      const assetType = _.get(task, 'asset.type');
      if (assetType === 'stop') {
        return _.get(task, 'asset.id', '');
      }
      return _.get(task, 'asset.stop.id', '');
    },
    component: (props) => React.createElement(LocationTaskFieldComponent, { ...props }),
    disabled: ({ formValues, task, loggedInUser, taskTypeOptions }) => {
      const formValueTaskType = _.get(formValues, 's_tasktype');
      const taskTypeExist = () => {
        if (!formValueTaskType || formValueTaskType === '') return false;
        return true;
      };
      const disabledInRole = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STOP_ASSET,
        user: loggedInUser,
      });
      if (disabledInRole) {
        return disabledInRole;
      }
      const taskType = taskTypeOptions.items.find((tt) => tt.value === formValueTaskType);
      if (taskType?.originalobject?.defaultLocationTask) {
        return true;
      }
      return !!(
        !taskTypeExist() ||
        (task.id && task.taskType && task.taskType.isLinkable) ||
        (task.linkedTaskIds && task.linkedTaskIds.length) ||
        task.isRecurring
      );
    },
    validations: [
      {
        validateFunc: ({ formValues, bulkCreateTasksView }) => {
          if (bulkCreateTasksView) {
            return true;
          }
          const stop = _.get(formValues, 's_stop');
          if (stop) {
            return true;
          }
          return false;
        },
        message: 'Stop is required',
      },
    ],
    hide: ({ bulkCreateTasksView }) => {
      return bulkCreateTasksView;
    },
  },
  s_asset: {
    name: 'asset',
    displayName: 'Asset',
    type: ATTRIBUTE_TYPE.CUSTOM,
    sequence: 6,
    path: (task) => {
      const assetType = _.get(task, 'asset.type');
      if (assetType === 'stop') {
        return '';
      }
      return _.get(task, 'asset.id');
    },
    component: (props) => React.createElement(LocationTaskFieldComponent, { ...props }),
    disabled: ({ formValues, task, loggedInUser, taskTypeOptions }) => {
      const formValueTaskType = _.get(formValues, 's_tasktype');
      const taskTypeExist = () => {
        if (!formValueTaskType || formValueTaskType === '') return false;
        return true;
      };
      const disabledInRole = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STOP_ASSET,
        user: loggedInUser,
      });
      if (disabledInRole) {
        return disabledInRole;
      }
      const taskType = taskTypeOptions.items.find((tt) => tt.value === formValueTaskType);
      if (taskType?.originalobject?.defaultLocationTask) {
        return true;
      }
      return !!(
        !taskTypeExist() ||
        (task.id && task.taskType && task.taskType.isLinkable) ||
        (task.linkedTaskIds && task.linkedTaskIds.length) ||
        task.isRecurring
      );
    },
    setValue: ({ formValues }) => {
      let assetId = _.get(formValues, 's_asset');
      if (_.isEmpty(assetId)) {
        assetId = _.get(formValues, 's_stop');
      }
      if (_.isEmpty(assetId)) {
        assetId = null;
      }
      return { assetId };
    },
    hide: ({ bulkCreateTasksView }) => {
      return bulkCreateTasksView;
    },
  },
  s_assetlevelsinfo: {
    name: 'assetLevelsInfo',
    displayName: 'Level2',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(AssetLevelInfoComponent, { ...props }),
    sequence: 7,
    disabled: ({ formValues, task, loggedInUser }) => {
      const formValueTaskType = _.get(formValues, 's_tasktype');
      const formValueAsset = _.get(formValues, 's_asset');
      const taskTypeExist = () => {
        if (!formValueTaskType || formValueTaskType === '') return false;
        return true;
      };
      const disabledInRole = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STOP_ASSET,
        user: loggedInUser,
      });
      if (disabledInRole) {
        return disabledInRole;
      }
      if (!formValueAsset) {
        return true;
      }
      return !!(
        !taskTypeExist() ||
        (task.id && task.taskType && task.taskType.isLinkable) ||
        (task.linkedTaskIds && task.linkedTaskIds.length) ||
        task.isRecurring
      );
    },
    hide: ({ formValues, settings, taskTypeOptions, assetLevelOptions }) => {
      const isFeatureEnabled = _.get(settings, 'featureFlags.enableAssetHierarchy', false) || false;
      if (!isFeatureEnabled) {
        return true;
      }
      const taskType = taskTypeOptions.items.find((tt) => tt.value === formValues.s_tasktype);
      if (!taskType?.originalobject?.allowAssetLevelsInfo) {
        return true;
      }
      // const { items = [] } = assetOptions;
      const formValueAsset = _.get(formValues, 's_asset');
      if (!formValueAsset) {
        return true;
      }
      return assetLevelOptions?.items.length === 0;
      // const asset = items.find((val) => val?.originalobject?.id === formValueAsset);
      // const optionsForLevel2 = (asset?.originalobject?.hierarchy ?? []).filter((h) => h.parentId);
      // return optionsForLevel2.length === 0;
    },
    isMandatory: false,
    hasOwnGridStyle: true,
    path: 'assetLevelsInfo',
  },
  s_assetCriteria: {
    name: 'assetCriteria',
    type: ATTRIBUTE_TYPE.CUSTOM,
    hide: ({ bulkCreateTasksView }) => {
      return !bulkCreateTasksView;
    },
    // eslint-disable-next-line react/jsx-filename-extension
    component: (props) => <AssetCriteriaComponent {...props} />,
    sequence: 5,
    setValue: ({ formValues }) => {
      return { assetCriteria: _.get(formValues, 's_assetCriteria') };
    },
    // optionsVariableName: PICKLIST_OPTIONS.ASSIGNEE,
    fullRow: true,
    componentWidth: 12,
    validations: [
      {
        validateFunc: ({ formValues, bulkCreateTasksView }) => {
          if (!bulkCreateTasksView) {
            return true;
          }
          const assetCriteria = formValues.s_assetCriteria || {};
          const { areaIds = [], assetIds = [] } = assetCriteria;

          return areaIds.length > 0 || assetIds.length > 0;
        },
        message: 'Areas or Locations Mandatory in Asset Criteria.',
      },
      {
        validateFunc: ({ formValues, bulkCreateTasksView }) => {
          if (!bulkCreateTasksView) {
            return true;
          }
          const assetCriteria = formValues.s_assetCriteria || {};
          const { customAttributes = {} } = assetCriteria;
          let isCustomAttributesValid = true;
          for (const key of Object.keys(customAttributes)) {
            if (customAttributes[key] === '') {
              isCustomAttributesValid = false;
            }
          }
          return isCustomAttributesValid;
        },
        message: 'Invalid Custom Attrbiutes in Asset Criteria.',
      },
    ],
  },
  s_priority: {
    name: 'priority',
    displayName: 'Priority',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(PriorityForTask, { ...props }),
    sequence: 9,
    path: 'priority',
    isMandatory: true,
    disabled: ({ task, loggedInUser }) => {
      return determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.PRIORITY,
        user: loggedInUser,
      });
    },
    validations: [
      {
        validateFunc: ({ formValues }) => {
          const priority = _.get(formValues, 's_priority');
          if (priority) {
            return true;
          }
          return false;
        },
        message: 'Priority is required',
      },
    ],
  },
  s_timetonextpriority: {
    name: 'timeToNextPriority',
    displayName: 'Time To Next Priority(days)',
    component: (props) => <TimeToNextPriority {...props} />,
    sequence: 10,
    type: ATTRIBUTE_TYPE.CUSTOM,
    path: 'timeToNextPriority',
    disabled: ({ task, loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TIME_TO_NEXT_PRIORITY,
        user: loggedInUser,
      }),
    isMandatory: true,

    validations: [
      {
        validateFunc: ({ formValues }) => {
          const timeToNextPriority = _.get(formValues, 's_timetonextpriority');
          if (timeToNextPriority) {
            return true;
          }
          return false;
        },
        message: 'Time To Next Priority is required',
      },
    ],
  },
  s_status: {
    name: 'status',
    displayName: 'Status',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 11,
    optionsVariableName: PICKLIST_OPTIONS.STATUS,
    path: 'status',
    isMandatory: true,
    disabled: ({ task, loggedInUser, taskTypeOptions, formValues }) => {
      const disabledByRole = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STATUS,
        user: loggedInUser,
      });
      if (disabledByRole) {
        return true;
      }
      if (!formValues.s_tasktype) {
        return true;
      }
      const taskType = taskTypeOptions?.items?.find((tt) => tt.value === formValues.s_tasktype);
      if (!task?.id && taskType?.originalobject?.isParent) {
        return true;
      }
      if (taskType?.originalobject?.allowTaskCreationWithResolvedStatus) {
        return false;
      }
      return !task?.id;
    },
  },
  s_priorityScore: {
    name: 'Score',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 12,
    path: 'priorityScore',
    step: '0.1',
    hide: ({ settings }) => {
      const isFeatureEnabled = _.get(settings, 'featureFlags.enableEditPriorityScore', false) || false;
      if (!isFeatureEnabled) {
        return true;
      }
      return false;
    },
  },
  s_desc: {
    name: 'Description',
    type: ATTRIBUTE_TYPE.TEXTFIELD,
    sequence: 12.5,
    path: 'data.s_desc',
    disabled: ({ task, loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.DESCRIPTION,
        user: loggedInUser,
      }),
  },
  s_generateMultiple: {
    name: 'Generate Multiple',
    type: ATTRIBUTE_TYPE.INTEGER,
    path: 'generateMultiple',
    dynamicNameFunc: ({ taskType }) => taskType?.generateMultipleLabelName || 'Number of Siblings',
    sequence: 13,
    hide: ({ task, taskType }) => {
      return task.id || taskType?.isParent || !taskType?.generateMultiple;
    },
  },
  s_assigneeid: {
    name: 'assigneeid',
    displayName: 'Assignees',
    type: ATTRIBUTE_TYPE.CUSTOM,
    hide: ({ taskTypeSelectedisParent }) => {
      return taskTypeSelectedisParent;
    },
    // eslint-disable-next-line react/jsx-filename-extension
    component: (props) => <AssigneeComponent {...props} />,
    sequence: 14,
    path: (task) => {
      const assigneeIds = _.get(task, 'assigneeIds', []);
      const ids = assigneeIds
        .filter((assigneeIdObj) => !assigneeIdObj.isDeleted)
        .map((assigneeIdObj) => assigneeIdObj.assigneeId);
      ids.push('');
      return ids;
    },
    setValue: ({ formValues, task, assigneeOptions }) => {
      const assigneeIdMap = _.keyBy(assigneeOptions.items, 'key');
      const existingAssigneeIds = task.assigneeIds.filter((assigneeIdObj) => !assigneeIdObj.isDeleted);
      const existingDeletedAssigneeIdObjects = task.assigneeIds.filter((assigneeIdObj) => assigneeIdObj.isDeleted);
      const existingAssigneeIdMap = _.keyBy(existingAssigneeIds, 'assigneeId');
      const openToNotReady =
        (formValues.s_status === STATUS_LIST.NOT_READY.key || formValues.s_status === STATUS_LIST.READYTOACCEPT.key) &&
        task.status === STATUS_LIST.OPEN.key;
      const formvalAssigneeIds = formValues.s_assigneeid.filter((val) => val);
      let assigneeIdObjects = formvalAssigneeIds.map((assigneeId) => {
        const obj = {
          assigneeId,
          isDeleted: false,
          sequence: _.get(existingAssigneeIdMap, `${assigneeId}.sequence`, null),
          vendorId: _.get(assigneeIdMap, `${assigneeId}.originalobject.vendorId`, null),
        };
        if (_.get(assigneeIdMap, `${assigneeId}.originalobject.isEquipmentResource`, null)) {
          const operatorId = formvalAssigneeIds.find((id) => id !== assigneeId);
          obj.operatorId = operatorId;
        }
        if (_.get(existingAssigneeIdMap, `${assigneeId}.isAccepted`, false) && !openToNotReady) {
          obj.isAccepted = _.get(existingAssigneeIdMap, `${assigneeId}.isAccepted`, false);
          obj.acceptedOn = _.get(existingAssigneeIdMap, `${assigneeId}.acceptedOn`);
        }
        return obj;
      });
      const deletedAssigneeIds = _.difference(
        existingAssigneeIds.map((assigneeIdObj) => assigneeIdObj.assigneeId),
        formValues.s_assigneeid
      );
      const deletedAssigneeObjects = deletedAssigneeIds.map((assigneeId) => ({
        assigneeId,
        isDeleted: true,
        sequence: null,
        vendorId: _.get(assigneeIdMap, `${assigneeId}.originalobject.vendorId`, null),
      }));
      assigneeIdObjects = _.uniqBy(
        [...assigneeIdObjects, ...deletedAssigneeObjects, ...existingDeletedAssigneeIdObjects],
        'assigneeId'
      );
      return { assigneeIds: assigneeIdObjects };
    },
    optionsVariableName: PICKLIST_OPTIONS.ASSIGNEE,
    fullRow: true,
    componentWidth: 12,
    validations: [
      {
        validateFunc: ({ taskTypeOptions, formValues }) => {
          const taskType = taskTypeOptions.items.find((tt) => tt.value === formValues.s_tasktype);
          const mandatoryAssignee = _.get(taskType, 'originalobject.mandatoryAssignee', false) || false;
          if (!mandatoryAssignee) {
            return true;
          }
          const assigneeIds = (formValues.s_assigneeid || []).filter((val) => val);
          return mandatoryAssignee && _.size(assigneeIds) > 0;
        },
        message: 'Assignee is mandatory',
      },
    ],
  },

  s_isHardAssignee: {
    name: 'isHardAssignee',
    displayName: 'Strict Hard Assignment',
    type: ATTRIBUTE_TYPE.CHECKBOX,
    sequence: 15,
    path: 'isHardAssignee',
    disabled: ({ task, loggedInUser }) =>
      determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STRICT_HARD_ASSIGNMENT,
        user: loggedInUser,
      }),
    hide: ({ taskTypeSelectedisParent }) => {
      return taskTypeSelectedisParent;
    },
  },
  s_copyGenerateMultipleAssignee: {
    name: 'copyGenerateMultipleAssignee',
    displayName: 'Copy Assignee to Siblings',
    type: ATTRIBUTE_TYPE.CHECKBOX,
    sequence: 16,
    path: 'copyGenerateMultipleAssignee',
    hide: ({ formValues, task, taskType }) => {
      const formvalAssigneeIds = (formValues?.s_assigneeid || []).filter((val) => val);
      return task.id || taskType?.isParent || !taskType?.generateMultiple || !formvalAssigneeIds.length;
    },
  },
  // s_onlyAllowManualScoreUpdate: {
  //   name: 'onlyAllowManualScoreUpdate',
  //   displayName: 'Only Allow Manual Score Update',
  //   type: ATTRIBUTE_TYPE.CHECKBOX,
  //   sequence: 11,
  //   path: 'onlyAllowManualScoreUpdate',
  // },
  s_timespent: {
    display_format: 'hh:mm',
    name: 'Task Time',
    type: 'time',
    hide: true,
    setValue: () => {
      return null;
    },
  },
  s_name: {
    name: 'Task Name',
    type: 'string',
    hide: true,
    setValue: ({ formValues, taskTypeOptions }) => {
      const taskType = taskTypeOptions.items.find((tt) => tt.value === formValues.s_tasktype);
      if (taskType) {
        return {
          data: {
            s_name: taskType.originalobject.name,
          },
        };
      }
      return {};
    },
  },
  s_estimatedtime: {
    display_format: 'hh:mm',
    name: 'Estimated Time',
    type: 'time',
    hide: true,
  },
  s_workflowversion: {
    name: 'workflowVersion',
    type: 'string',
    hide: true,
    setValue: ({ formValues, taskTypeOptions }) => {
      const taskType = taskTypeOptions.items.find((tt) => formValues.s_tasktype === tt.value);
      if (taskType && taskType.originalobject.isParent) {
        return { workflowVersion: 'v1' };
      }
      return {};
    },
  },
  s_fieldId: {
    name: 'fieldId',
    type: 'string',
    hide: true,
    setValue: ({ fieldId }) => {
      return { fieldId };
    },
  },
  s_cost: {
    name: 'Costs',
    type: 'decimal',
    uom: 'USD',
    hide: true,
  },
  s_cummulativehourrate: {
    name: 'cumulativeHourRate',
    displayName: 'Cumulative Hourly Rate($)',
    disabled: true,
    hide: true,
    type: ATTRIBUTE_TYPE.DECIMAL,
    value: ({ formValues, assigneeOptions }) => {
      const assigneeIds = _.get(formValues, 's_assigneeid', []);
      const assigneeOptionsKeyed = _.keyBy(assigneeOptions.items, 'key');
      const cumulativeHourRate = assigneeIds.reduce((totalRate, assigneeId) => {
        return totalRate + _.get(assigneeOptionsKeyed, `${assigneeId}.originalobject.contractHourlyRate`, 0);
      }, 0);
      return `${cumulativeHourRate}`;
    },
  },
  s_isrecurring: {
    name: 'isRecurring',
    hide: true,
    setValue: ({ task, formValues }) => {
      return {
        isRecurring: !!(!task.sourceRecurringTaskId && formValues.schedule_eventsource === EVENT_SOURCE.RECURRING),
      };
    },
  },
  schedule_eventsource: {
    name: 'eventSource',
    displayName: 'Source',
    type: ATTRIBUTE_TYPE.PICKLIST,
    optionsVariableName: PICKLIST_OPTIONS.EVENT_SOURCE,
    sequence: 1,
    path: 'eventSource',
    fullRow: true,
    disabled: ({ task, loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return TaskUtilities.isTaskChild(task) || TaskUtilities.isTaskOccurrenceOfRecurring(task);
    },
    isMandatory: true,
  },
  schedule_duedate: {
    name: 'dueDate',
    displayName: 'Date',
    type: ATTRIBUTE_TYPE.DATE,
    sequence: 2,
    path: (task) => {
      return moment(task.startTime).format(INPUT_TYPE_FORMAT.date);
    },
    hide: ({ formValues, task }) => {
      return formValues.schedule_eventsource === EVENT_SOURCE.RECURRING && !task.sourceRecurringTaskId;
    },
    isMandatory: true,
    fullRow: true,
    disabled: ({ task, loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return task.isTaskLocked;
    },
  },
  schedule_starttime: {
    name: 'startTime',
    displayName: 'Start Time',
    type: ATTRIBUTE_TYPE.TIME,
    sequence: 3,
    path: (task) => {
      return moment(task.startTime).format(INPUT_TYPE_FORMAT.time);
    },
    isMandatory: true,
    step: 1,
    setValue: ({ formValues }) => {
      return {
        startTime: DateUtils.convertToUTCDate(formValues.schedule_duedate, formValues.schedule_starttime).toISOString(),
      };
    },
    disabled: ({ task, loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return task.isTaskLocked;
    },
  },
  schedule_duration: {
    name: 'duration',
    displayName: 'Default Duration(Minutes)',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 4,
    hide: ({ taskTypeSelectedisParent }) => {
      return taskTypeSelectedisParent;
    },
    path: 'duration',
    isMandatory: true,
    disabled: ({ task, loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return task.isTaskLocked;
    },
  },
  schedule_totalcost: {
    name: 'totalCost',
    displayName: 'Total Cost($}',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 8,
    hide: true,
    disabled: true,
    value: ({ formValues, assigneeOptions }) => {
      const assigneeIds = _.get(formValues, 's_assigneeid', []);
      const assigneeOptionsKeyed = _.keyBy(assigneeOptions.items, 'key');
      const cumulativeHourRate = assigneeIds.reduce((totalRate, assigneeId) => {
        return totalRate + _.get(assigneeOptionsKeyed, `${assigneeId}.originalobject.contractHourlyRate`, 0);
      }, 0);
      const duration = parseInt(_.get(formValues, 'schedule_duration', 0), 10);
      let totalCost = (cumulativeHourRate * duration) / 60;
      if (totalCost % 1 !== 0) {
        totalCost = totalCost.toFixed(2);
      }
      return totalCost;
    },
  },
  schedule_hardstarttime: {
    name: 'hardStartTime',
    displayName: 'Hard Start Time',
    type: ATTRIBUTE_TYPE.CHECKBOX,
    sequence: 8,
    componentWidth: 11,
    path: 'isHardStartTime',
    disabled: ({ task, loggedInUser }) => {
      return determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.STRICT_HARD_START_TIME,
        user: loggedInUser,
      });
    },
  },
  schedule_endtime: {
    name: 'endTime',
    displayName: 'End Time',
    type: ATTRIBUTE_TYPE.TIME,
    sequence: 5,
    disabled: true,
    hide: ({ taskTypeSelectedisParent }) => {
      return taskTypeSelectedisParent;
    },
    value: ({ formValues }) => {
      const startTime = _.get(formValues, 'schedule_starttime', moment().format(INPUT_TYPE_FORMAT.time));
      const dueDate = _.get(formValues, 'schedule_duedate', moment().format(INPUT_TYPE_FORMAT.date));
      const duration = _.get(formValues, 'schedule_duration', 0);
      return moment(`${dueDate}T${startTime}`).add(duration, 'minutes').format(INPUT_TYPE_FORMAT.time);
    },
    setValue: ({ formValues }) => {
      return {
        endTime: moment(DateUtils.convertToUTCDate(formValues.schedule_duedate, formValues.schedule_starttime))
          .add(formValues.schedule_duration, 'minutes')
          .toISOString(),
      };
    },
    step: 1,
  },
  schedule_delayminutes: {
    name: 'delayMinutes',
    displayName: 'Delayed By',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 6,
    path: 'delayMinutes',
    hide: ({ taskTypeSelectedisParent }) => {
      return taskTypeSelectedisParent;
    },
    disabled: ({ loggedInUser, task }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return false;
    },
  },
  schedule_timespent: {
    name: 'timespent',
    displayName: 'Time Spent(in minutes)',
    type: ATTRIBUTE_TYPE.DECIMAL,
    sequence: 7,
    hide: ({ task }) => {
      if (task?.id && TaskUtilities.isTaskRegular(task)) {
        return false;
      }
      return true;
    },
    path: (task) => {
      const timespentInSec = parseInt(task?.data?.s_timespent, 10);
      if (timespentInSec) {
        const minutes = timespentInSec / 60;
        return minutes;
      }
      return 0;
    },
    setValue: ({ formValues }) => {
      if (formValues.schedule_timespent) {
        const timeSpentMinute = formValues.schedule_timespent; // split it at the colons
        // Hours are worth 60 minutes.
        const timeSpentInSeconds = parseInt(timeSpentMinute || 0) * 60;
        if (timeSpentInSeconds) {
          return { data: { s_timespent: `${timeSpentInSeconds}`, a_timespent_edited: true } };
        }
        return { data: { s_timespent: `${timeSpentInSeconds}` } };
      }
      return null;
    },
    disabled: ({ task, loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      return disabled;
    },
    validations: [
      {
        validateFunc: ({ formValues, task }) => {
          const statusIsResolved = formValues.s_status === STATUS_LIST.RESOLVED.key;
          const enforceTimeSpent = task?.taskType?.enforceTimeSpent;
          const timeSpentMinute = formValues.schedule_timespent || '';
          const timeSpentInSeconds = parseInt(timeSpentMinute || 0) * 60;
          if (!timeSpentInSeconds && statusIsResolved && task.status !== STATUS_LIST.RESOLVED.key && enforceTimeSpent) {
            return false;
          }
          return true;
        },
        message: 'Timespent is required',
      },
    ],
  },
  schedule_recurring: {
    name: 'recurring',
    displayName: 'Recurring Details',
    type: ATTRIBUTE_TYPE.CUSTOM,
    // eslint-disable-next-line react/jsx-filename-extension
    component: (props) => <RecurringFormFields {...props} />,
    hide: ({ formValues, task }) =>
      formValues.schedule_eventsource !== EVENT_SOURCE.RECURRING || task.sourceRecurringTaskId,
    sequence: 2,
    fullRow: true,
    disabled: ({ task, loggedInUser }) => {
      const disabled = determineIfUserHasFieldsDisabled({
        resource: RESOURCES.ENTITY.TASK,
        entityAccessType: task.id ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
        field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_SCHEDULE,
        user: loggedInUser,
      });
      if (disabled) {
        return true;
      }
      return !!TaskUtilities.isTaskChild(task);
    },
    path: (task) => {
      const rruleString = _.get(task, 'schedule.rrule');
      const overwriteEditedOccurrences = _.get(task, 'schedule.overwriteEditedOccurrences', true);
      const allowPileups = _.get(task, 'schedule.allowPileups', true);
      const displayUptoDays = _.get(task, 'schedule.displayUptoDays', 0);
      if (rruleString) {
        const rruleObj = RRule.parseString(rruleString);
        delete rruleObj.byhour;
        delete rruleObj.byminute;
        delete rruleObj.bysecond;
        delete rruleObj.wkst;
        const dateStartAtCurrentTZ = moment(rruleObj.dtstart).date();
        const dateStartAtUTC = moment(rruleObj.dtstart).utc().date();
        if (dateStartAtCurrentTZ > dateStartAtUTC) {
          if (rruleObj.freq === RRule.WEEKLY) {
            rruleObj.byweekday = rruleObj.byweekday.map((weekday) =>
              RRuleFunctions.getRRuleWeekDay(RRuleFunctions.getDayNoForRRuleWeekDay(weekday) + 1)
            );
          } else if (rruleObj.freq === RRule.MONTHLY) {
            rruleObj.bymonthday = (rruleObj.bymonthday % 30) + 1;
          }
        } else if (dateStartAtCurrentTZ < dateStartAtUTC) {
          if (rruleObj.freq === RRule.WEEKLY) {
            rruleObj.byweekday = rruleObj.byweekday.map((weekday) =>
              RRuleFunctions.getRRuleWeekDay(RRuleFunctions.getDayNoForRRuleWeekDay(weekday) + 6)
            );
          } else if (rruleObj.freq === RRule.MONTHLY) {
            rruleObj.bymonthday = ((rruleObj.bymonthday + 28) % 30) + 1;
          }
        }
        return {
          frequencytype: RRULE_FREQUENCY_MAP[rruleObj.freq],
          dailyinterval: rruleObj.freq === RRule.DAILY ? rruleObj.interval : 1,
          monthlyinterval: rruleObj.freq === RRule.MONTHLY ? rruleObj.interval : 1,
          byweekday: _.get(rruleObj, 'byweekday', []),
          bymonthday: _.get(rruleObj.bymonthday, 1),
          startdate: DateUtils.convertDateToYYYYMMDDFormat(rruleObj.dtstart),
          enddate: DateUtils.convertDateToYYYYMMDDFormat(rruleObj.until),
          overwriteEditedOccurrences,
          allowPileups,
          displayUptoDays,
        };
      }
      return {
        frequencytype: RRULE_FREQUENCY_MAP[RRule.DAILY],
        dailyinterval: 1,
        monthlyinterval: 1,
        byweekday: [],
        bymonthday: 1,
        startdate: DateUtils.convertDateToYYYYMMDDFormat(moment()),
        enddate: '2030-12-30',
        overwriteEditedOccurrences,
        allowPileups,
        displayUptoDays,
      };
    },
    setValue: ({ formValues }) => {
      if (formValues.schedule_eventsource !== EVENT_SOURCE.RECURRING) {
        return { schedule: null };
      }
      const startDate = _.get(formValues, 'schedule_recurring.startdate');
      const endDate = _.get(formValues, 'schedule_recurring.enddate');
      const frequencyType = _.get(formValues, 'schedule_recurring.frequencytype');
      const displayUptoDays = _.get(formValues, 'schedule_recurring.displayUptoDays');
      const allowPileups = _.get(formValues, 'schedule_recurring.allowPileups');
      const overwriteEditedOccurrences = _.get(formValues, 'schedule_recurring.overwriteEditedOccurrences');
      const dtstart = DateUtils.setTimeToDate(new Date(`${startDate}T00:00`), formValues.schedule_starttime);
      const dateStartAtCurrentTZ = moment(dtstart).date();
      const dateStartAtUTC = moment(dtstart).utc().date();
      let byweekday = _.get(formValues, 'schedule_recurring.byweekday') || [];
      let bymonthday = _.get(formValues, 'schedule_recurring.bymonthday') || 1;
      if (dateStartAtCurrentTZ > dateStartAtUTC) {
        if (frequencyType === RRULE_FREQUENCY_MAP[RRule.WEEKLY]) {
          byweekday = byweekday.map((weekday) =>
            RRuleFunctions.getRRuleWeekDay(RRuleFunctions.getDayNoForRRuleWeekDay(weekday) + 6)
          );
        } else if (frequencyType === RRULE_FREQUENCY_MAP[RRule.MONTHLY]) {
          bymonthday = ((parseInt(bymonthday) + 28) % 30) + 1;
        }
      } else if (dateStartAtCurrentTZ < dateStartAtUTC) {
        if (frequencyType === RRULE_FREQUENCY_MAP[RRule.WEEKLY]) {
          byweekday = byweekday.map((weekday) =>
            RRuleFunctions.getRRuleWeekDay(RRuleFunctions.getDayNoForRRuleWeekDay(weekday) + 1)
          );
        } else if (frequencyType === RRULE_FREQUENCY_MAP[RRule.MONTHLY]) {
          bymonthday = (parseInt(bymonthday) % 30) + 1;
        }
      } else {
        bymonthday = parseInt(bymonthday);
      }
      const INVERTED_RRULE_FREQUENCY_MAP = _.invert(RRULE_FREQUENCY_MAP);
      const rrule = {
        dtstart,
        until: DateUtils.setTimeToDate(new Date(`${endDate}T00:00`), formValues.schedule_starttime),
        interval:
          // eslint-disable-next-line no-nested-ternary
          frequencyType === RRULE_FREQUENCY_MAP[RRule.DAILY]
            ? _.get(formValues, 'schedule_recurring.dailyinterval')
            : frequencyType === RRULE_FREQUENCY_MAP[RRule.MONTHLY]
            ? _.get(formValues, 'schedule_recurring.monthlyinterval')
            : null,
        byweekday: frequencyType === RRULE_FREQUENCY_MAP[RRule.WEEKLY] ? byweekday : null,
        bymonthday: frequencyType === RRULE_FREQUENCY_MAP[RRule.MONTHLY] ? bymonthday : null,
        freq: INVERTED_RRULE_FREQUENCY_MAP[frequencyType],
      };

      return {
        schedule: {
          rrule: RRule.optionsToString(new RRule(rrule).options),
          displayUptoDays,
          allowPileups,
          overwriteEditedOccurrences,
        },
      };
    },
    validations: [
      {
        validateFunc: ({ formValues }) => {
          const eventSource = formValues.schedule_eventsource;
          const startDate = _.get(formValues, 'schedule_recurring.startdate');
          if (eventSource === EVENT_SOURCE.RECURRING) {
            return /\d{3}-\d{2}-\d{2}/.test(startDate);
          }
          return true;
        },
        message: 'Start Date is required',
      },
      {
        validateFunc: ({ formValues }) => {
          const eventSource = formValues.schedule_eventsource;
          const endDate = _.get(formValues, 'schedule_recurring.enddate');
          if (eventSource === EVENT_SOURCE.RECURRING) {
            return /\d{3}-\d{2}-\d{2}/.test(endDate);
          }
          return true;
        },
        message: 'End Date is required',
      },
      {
        validateFunc: ({ formValues, task }) => {
          const eventSource = formValues.schedule_eventsource;
          const startDate = _.get(formValues, 'schedule_recurring.startdate');
          const endDate = _.get(formValues, 'schedule_recurring.enddate');
          if (eventSource === EVENT_SOURCE.RECURRING && !task.sourceRecurringTaskId) {
            return endDate > startDate;
          }
          return true;
        },
        message: 'End Date should be greater than Start Date',
      },
      {
        validateFunc: ({ formValues, task }) => {
          const eventSource = formValues.schedule_eventsource;
          const frequencyType = _.get(formValues, 'schedule_recurring.frequencytype');
          const byWeekday = _.get(formValues, 'schedule_recurring.byweekday');
          if (
            eventSource === EVENT_SOURCE.RECURRING &&
            !task.sourceRecurringTaskId &&
            frequencyType === RRULE_FREQUENCY_MAP[RRule.WEEKLY]
          ) {
            return !!(byWeekday && byWeekday.length > 0);
          }
          return true;
        },
        message: 'Please select at least one week day',
      },
      {
        validateFunc: ({ formValues, task = {} }) => {
          const eventSource = formValues.schedule_eventsource;
          const displayUptoDays = _.get(formValues, 'schedule_recurring.displayUptoDays');
          const isTasksValid = task && task.id ? TaskUtilities.isTaskSeriesOfRecurrence(task) : true;
          if (eventSource === EVENT_SOURCE.RECURRING && (displayUptoDays > 60 || displayUptoDays < 0) && isTasksValid) {
            return false;
          }
          return true;
        },
        message: 'The value should be between 0 and 60 (including)',
      },
    ],
  },
  audit_createdby: {
    name: 'createdBy',
    displayName: 'Created By',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 1,
    hide: ({ formValues }) => !formValues.audit_createdby,
    path: (task) => task.createdBy,
  },
  audit_createdon: {
    name: 'createdOn',
    displayName: 'Created On',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 2,
    hide: ({ formValues }) => !formValues.audit_createdon,
    path: (task) => task.createdOn && DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(task.createdOn),
  },
  audit_approvedby: {
    name: 'approvedBy',
    displayName: 'Approved By',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 3,
    hide: ({ formValues }) => !formValues.audit_approvedby,
    path: (task) => task.approvedBy,
    setValue: ({ task, loggedInUser }) => {
      if (!task.id) {
        return { approvedBy: loggedInUser.userName };
      }
      return {};
    },
  },
  audit_approvedon: {
    name: 'approvedOn',
    displayName: 'Approved On',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 4,
    hide: ({ formValues }) => !formValues.audit_approvedon,
    path: (task) => task.approvedOn && DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(task.approvedOn),
    setValue: ({ task }) => {
      if (!task.id) {
        return { approvedOn: new Date().toISOString() };
      }
      return {};
    },
  },
  audit_modifiedby: {
    name: 'modifiedBy',
    displayName: 'Modified By',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 5,
    hide: ({ formValues }) => !formValues.audit_modifiedby,
    path: (task) => task.modifiedBy,
  },
  audit_modifiedon: {
    name: 'modifiedOn',
    displayName: 'Modified On',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 6,
    hide: ({ formValues }) => !formValues.audit_modifiedon,
    path: (task) => task.modifiedOn && DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(task.modifiedOn),
  },
  audit_resolvedby: {
    name: 'resolvedBy',
    displayName: 'Resolved By',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 7,
    hide: ({ formValues }) => !formValues.audit_resolvedby,
    path: (task) => task.resolvedBy,
    setValue: ({ task, formValues, loggedInUser }) => {
      if (task.id && formValues.s_status === STATUS_LIST.RESOLVED.key && task.status !== formValues.s_status) {
        return { resolvedBy: loggedInUser.userName };
      }
      return {};
    },
  },
  audit_resolvedon: {
    name: 'resolvedOn',
    displayName: 'Resolved On',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 8,
    hide: ({ formValues }) => !formValues.audit_resolvedon,
    path: (task) => task.resolvedOn && DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(task.resolvedOn),
    setValue: ({ task, formValues }) => {
      if (task.id && formValues.s_status === STATUS_LIST.RESOLVED.key && task.status !== formValues.s_status) {
        return { resolvedOn: new Date().toISOString() };
      }
      return {};
    },
  },
  audit_assignedon: {
    name: 'assignedOn',
    displayName: 'Assigned On',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 9,
    hide: ({ formValues }) => !formValues.audit_assignedon,
    path: (task) => task.assignedOn && DateUtils.convertUTCDateStringToYYYYMMDDHHMMSSFormat(task.assignedOn),
    setValue: ({ formValues, task }) => {
      const prevAssigneeIds = task.assigneeIds && task.assigneeIds.filter((a) => !a.isDeleted).map((a) => a.assigneeId);
      const currentAssigneeIds = formValues.s_assigneeid;
      const xorAssigneeIds = _.xor(prevAssigneeIds, currentAssigneeIds);
      if (xorAssigneeIds && xorAssigneeIds.length > 0) {
        const currentTime = new Date().toISOString();
        return { assignedOn: currentTime };
      }
      return {};
    },
  },
  audit_resolvedvia: {
    name: 'resolvedvia',
    displayName: 'Resolved Via',
    type: ATTRIBUTE_TYPE.STRING,
    sequence: 10,
    disabled: true,
    hide: ({ formValues }) => !formValues.audit_resolvedvia,
    path: (task) => _.get(task, 'data.s_resolved_device', ''),
    setValue: ({ formValues, task }) => {
      const prevStatus = task.status;
      const currStatus = formValues.s_status;
      if (currStatus !== prevStatus && currStatus === STATUS_LIST.RESOLVED.key) {
        return { data: { s_resolved_device: RESOLVED_VIA.ADMIN } };
      }
      return {};
    },
  },
  audit_resolvedat: {
    name: 'resolvedat',
    displayName: 'Resolve Lat/Long (If Mobile)',
    type: ATTRIBUTE_TYPE.STRING,
    disabled: true,
    sequence: 11,
    hide: ({ formValues }) => !formValues.audit_resolvedat,
    path: (task) => {
      const lat = _.get(task, 'data.s_resolved_lat', '');
      const lng = _.get(task, 'data.s_resolved_long', '');
      if (lat && lng) {
        return `${lat} ; ${lng}`;
      }
      return '';
    },
  },
  c_actualcost: {
    uom: 'USD',
    name: 'Actual Cost',
    type: ATTRIBUTE_TYPE.DECIMAL,
    hide: true,
    setValue: () => {},
  },
  c_uplift: {
    uom: 'bbls/day',
    name: 'Uplift',
    type: ATTRIBUTE_TYPE.DECIMAL,
    hide: true,
    setValue: () => {},
  },
  notification_watchers: {
    name: 'watchers',
    displayName: 'Watchers',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 1,
    path: 'watcherIds',
    optionsVariableName: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS,
    multiple: true,
  },
  parts_required: {
    name: 'parts',
    displayName: 'Parts Required',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => <PartsComponent {...props} />,
    sequence: 1,
    disabled: false,
    path: (task) => {
      const parts = _.cloneDeep(task.parts) || [];
      parts.push({ picklistId: '', picklistOptionId: '', quantity: 0 });
      return parts;
    },
    setValue: ({ formValues }) => {
      const clonedParts = _.cloneDeep(formValues.parts_required);
      const parts = clonedParts.filter((part) => part.picklistId && part.picklistOptionId && part.quantity);
      return { parts };
    },
    validations: mapErrorToField,
  },
  approval_matrixInfo: {
    name: 'approvalMatrixInfo',
    displayName: 'Approval Requirement',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => <ApprovalRequirementComponent {...props} />,
    sequence: 2,
    disabled: false,
    path: (task) => {
      const approvalMatrixInfo = _.cloneDeep(task.approvalInfo);
      return approvalMatrixInfo;
    },
    setValue: ({ formValues }) => {
      const approvalInfo = _.cloneDeep(formValues.approval_matrixInfo);
      return {
        approvalInfo,
      };
    },
    validations: ({ formValues }) => {
      const error = [];
      const approval = _.get(formValues, 'approval_matrixInfo', []) ?? [];
      approval.forEach((matrix, matrixIndex) => {
        (matrix.approvers || []).forEach(({ approvers }, approverIndex) => {
          const findApprover = approvers.find((approver) => approver.selected === true);
          if (!findApprover) {
            if (!error[matrixIndex]) {
              error[matrixIndex] = { approvers: [] };
            }
            error[matrixIndex].approvers[approverIndex] = 'Approvers are required';
          }
        });
      });
      return { isValid: error.length === 0, error };
    },
  },
  approval_requestors: {
    name: 'requesters',
    displayName: 'Requesters',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 1,
    path: 'requestorIds',
    optionsVariableName: PICKLIST_OPTIONS.REQUESTERS,
    multiple: true,
    fullRow: true,
    validations: [
      {
        validateFunc: ({ formValues, task }) => {
          const requestors = _.get(formValues, 'approval_requestors') || [];
          const approvalInfo = _.get(task, 'approvalInfo', []) || [];
          if (task.id && !requestors.length && approvalInfo.length) {
            return false;
          }
          return true;
        },
        message: 'Requestors is required',
      },
    ],
  },
  [ATTACHMENT_SCHEMA]: {
    name: 'attachments',
    displayName: 'Attachment',
    type: ATTRIBUTE_TYPE.CUSTOM,
    component: (props) => React.createElement(TaskAdhocAttachment, { ...props }),
    path: 'attachments',
  },
  watcher_groups: {
    name: 'watcherGroups',
    displayName: 'Watcher Groups',
    type: ATTRIBUTE_TYPE.PICKLIST,
    sequence: 1,
    path: 'watcherGroupIds',
    optionsVariableName: PICKLIST_OPTIONS.WATCHER_GROUPS,
    multiple: true,
    validations: [
      {
        validateFunc: ({ taskTypeOptions, formValues }) => {
          const taskType = taskTypeOptions.items.find((tt) => tt.value === formValues.s_tasktype);
          const mandatoryWatcherGroups = _.get(taskType, 'originalobject.mandatoryWatcherGroups', false) || false;
          if (!mandatoryWatcherGroups) {
            return true;
          }
          return mandatoryWatcherGroups && _.size(formValues.watcher_groups) > 0;
        },
        message: 'Watchergroup is required',
      },
    ],
  },
};
